<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar-menu></sidebar-menu>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title + ' - ' + namaCompany" :title1="title1" />
        <!-- /add -->
        <div class="card">
          <div class="card-body">
            <!-- <Form @submit="update" :validation-schema="schema" v-slot="{ errors }"> -->
            <form @submit.prevent="insert">
              <div class="row">
                <div class="col-lg-12 col-sm-12 col-12">
                  <div class="form-group">
                    <div class="d-flex justify-content-between ">
                      <label>Serial Number <span class="text-danger">*</span></label>
                    </div>
                    <input type="text" id="serialNumber" class="form-control"  v-model="currentData.sn" placeholder="">
                    
                  </div>
                </div>

                <div class="col-lg-12 col-sm-12 col-12">
                  <div class="form-group">
                    <label for="machineName">Nama Mesin</label>
                    <input type="text" id="machineName" class="form-control" v-model="currentData.nama" maxlength="100" placeholder="Mis. Pintu Depan / Gudang">
                  </div>
                </div>

                <div class="col-lg-12 col-sm-12 col-12">
                  <div class="form-group">
                    <label for="apiKey">API Key ADMS</label>
                    <input type="password" id="apiKey" class="form-control" v-model="currentData.api_key" autocomplete="new-password" placeholder="Per company, untuk Sync dan isi Private Key otomatis. Kosongkan jika tidak diubah">
                  </div>
                </div>

                <div class="col-lg-12 col-sm-12 col-12">
                  <div class="form-group">
                    <label for="privateKey">Private Key ADMS</label>
                    <input type="password" id="privateKey" class="form-control" v-model="currentData.private_key" autocomplete="new-password" placeholder="Mesin ADMS: boleh kosong jika API Key ADMS sudah diisi">
                  </div>
                </div>

                
                

                <div class="col-lg-12">
                  <button type="submit" class="btn btn-submit me-2">Save</button>
                  <router-link to="devices" class="btn btn-cancel">Cancel</router-link>
                </div>
              </div>

            </form>
          </div>
        </div>
        <!-- /add -->
      </div>
    </div>
  </div>
</template>

<style scoped>
.form-group input[type="datetime-local"] {
  border: 1px solid rgba(145, 158, 171, 0.32);
  height: 40px;
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  color: #637381;
  padding: 10px 15px;
  border-radius: 5px;
}

.form-group input[type="time"] {
  border: 1px solid rgba(145, 158, 171, 0.32);
  height: 40px;
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  color: #637381;
  padding: 10px 15px;
  border-radius: 5px;
}

.form-group input[type="datetime-local"]:focus {
  border: 1px solid rgba(82, 183, 127, 255);

}

.form-group input[type="time"]:focus {
  border: 1px solid rgba(82, 183, 127, 255);

}
</style>

<script>
import Cookies from "js-cookie";
import axios from "axios";
import { base_url, AlertPopup2, goPage, AlertBottom, appendForm, timeout, selectedBranch, rupiahInput, rupiahoutput } from "@/assets/js/function";
import { ModelSelect, MultiSelect } from 'vue-search-select';

export default {
  components: {
    ModelSelect,
    MultiSelect
  },
  name: "adddevices",
  data() {
    return {
      filter: true,
      title: "Insert Devices",
      title1: "Add new devices",
      namaCompany: '',
      config: "",
      api: "",
      value: "",
      //data
      currentData: {
        sn: '',
        nama: '',
        private_key: '',
        api_key: '',
      },
      currentDate: new Date,
      
    };
  },

  created() {
    const token = Cookies.get("token_refresh");
    this.config = {
      headers: {
        Authorization: `Bearer ` + token,
      },
      timeout: 30000,
    }
    
    const branch = parseInt(localStorage.getItem("selectedBranch")) || 0;

    //Update local and shared state
    this.filter = branch;
    selectedBranch.value = branch;

    localStorage.setItem('actionState', 'insert')
    
    this.namaCompany = localStorage.getItem('namaCompany');

   

  },
  methods: {
    formatCurrency(name) {
        this.currentData[name] = rupiahInput(this.currentData[name]);
    },
    


    formatDateLocal(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-based
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    },

    async insert() {
      
      
      let formData = new FormData();
      appendForm(formData)

      formData.append('sn', this.currentData.sn)
      formData.append('nama', this.currentData.nama || '')
      formData.append('private_key', this.currentData.private_key || '')
      formData.append('api_key', this.currentData.api_key || '')

      for (let [key, value] of formData.entries()) {
        console.log(`${key}: ${value}`);
      }
      // CloseLoading();
      // return false;

      const api = base_url + '/v3/machine_secure/insert';
      const res = await axios.post(api, formData, { timeout });
      const data = res.data;

      if(data.status){
        AlertBottom(data.message);
        goPage('devices');
        
      }else {
        AlertPopup2("error", "", data.message, true, 1500);
      }

    },

  },

};
</script>
